export const openProjectTakhmeenReceiptPrint = (id: string | number) => {
  window.open(`#/ptr-rcpt/${id}`, "_blank");
};
